import type React from 'react'
import type { ThemeSlotName } from './themeSlotNames'

type ThemeSlotProps = {
  /** Stable slot name used for docs and future theme partial overrides. */
  name: ThemeSlotName | (string & {})
  /** Content rendered when no theme-specific slot content is registered. */
  fallback: React.ReactNode
}

/**
 * Named extension point (WordPress-style hook/slot).
 * V1.1: passthrough of `fallback`. Layouts declare slots via `THEME_SLOT_NAMES`;
 * structural themes still prefer path mirroring for full chrome forks.
 */
export function ThemeSlot({ fallback }: ThemeSlotProps) {
  return fallback
}
